import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import CompanionCarousel from './CompanionCarousel';
import { MainContentSkeleton } from './AppSkeleton';
import { Companion } from '../api/model';
import { useCompanionService } from '../hooks/useServices';

interface MainContentProps {
  onStartChat: (companion: Companion) => void;
}

function MainContent({ onStartChat }: MainContentProps) {
  const companionService = useCompanionService();
  const [featuredCompanion, setFeaturedCompanion] = useState<Companion | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [companions, setCompanions] = useState<Companion[]>([]);

  useEffect(() => {
    const fetchCompanions = async () => {
      try {
        setIsLoading(true);
        const response = await companionService.getCompanions({
          per_page: 100,
        });
        if (response.success) {
          setFeaturedCompanion(response.data.companions[0]);
          setCompanions(response.data.companions);
        }
      } catch (error) {
        console.error(`Failed to fetch companions:`, error);
        setCompanions([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCompanions();
  }, [companionService]);

  const handleCompanionSelect = (companion: Companion) => {
    setFeaturedCompanion(companion);
  };

  if (isLoading || !featuredCompanion) {
    return <MainContentSkeleton />;
  }
  return (
    <div className="flex-1 overflow-y-auto bg-kind-deep">
      <HeroSection onStartChat={onStartChat} featuredCompanion={featuredCompanion} />
      <div className="py-8 lg:py-12 space-y-12 lg:space-y-16">
        <CompanionCarousel
          category={'Career'}
          onStartChat={onStartChat}
          onCompanionSelect={handleCompanionSelect}
          featuredCompanion={featuredCompanion}
          companions={companions}
        />
        <CompanionCarousel
          category={'Relationships'}
          onStartChat={onStartChat}
          onCompanionSelect={handleCompanionSelect}
          featuredCompanion={featuredCompanion}
          companions={companions}
        />
        <CompanionCarousel
          category={'Health'}
          onStartChat={onStartChat}
          onCompanionSelect={handleCompanionSelect}
          featuredCompanion={featuredCompanion}
          companions={companions}
        />
        <CompanionCarousel
          category={'Personal Growth'}
          onStartChat={onStartChat}
          onCompanionSelect={handleCompanionSelect}
          featuredCompanion={featuredCompanion}
          companions={companions}
        />
      </div>
    </div>
  );
}

export default MainContent;
